import {
  ArrowClockwise,
  CaretDoubleRightIcon,
  ClockUser,
} from "@phosphor-icons/react";
import { Button, Card } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useRecentActivity } from "../../../hooks/get";
import Activities from "../../UserActivity/components/Activities";

const RecentUserActivityComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    data: activityData,
    isLoading,
    isPlaceholderData,
    refetch,
    isRefetching,
  } = useRecentActivity({
    page: 1,
    per_page: 4,
  });
  return (
    <Card
      theme={{
        root: {
          base: `flex rounded-lg border border-gray-200 bg-white dark:border-neutral-700 dark:bg-neutral-800 overflow-hidden min-h-[482px]`,
          children: "p-4 relative h-full",
        },
      }}
    >
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-2">
          <ClockUser size={20} className="text-gray-700 dark:text-gray-300" weight="duotone" />
          <h1 className="text-md font-bold text-gray-700 dark:text-gray-300">
            {t("dashboard.recentUserActivity")}
          </h1>
        </div>
        <div className="flex gap-2 items-center">
          <Button
            size="xs"
            outline
            color="indigo"
            onClick={() => refetch()}
            disabled={isRefetching}
          >
            <div className="flex items-center gap-1">
              {t("common.refresh")}
              <ArrowClockwise
                size={16}
                weight="duotone"
                className={`${isRefetching ? "animate-spin" : ""}`}
              />
            </div>
          </Button>
          <Button
            size="xs"
            outline
            color="indigo"
            onClick={() => navigate("/user-activity")}
          >
            <div className="flex items-center gap-1">
              {t("userActivity.seeAllActivity")}
              <CaretDoubleRightIcon size={16} weight="duotone" />
            </div>
          </Button>
        </div>
      </div>
      <Activities
        key={(isLoading || isPlaceholderData || isRefetching).toString()}
        activityData={activityData?.results || []}
        isLoading={isLoading || isPlaceholderData || isRefetching}
      />
      <div className="absolute bottom-0 left-0 bg-gradient-to-t from-white to-transparent dark:from-neutral-900 dark:to-transparent w-full h-1/6 backdrop-blur-[1px]"></div>
    </Card>
  );
};

export default RecentUserActivityComponent;
